import { pageSizeEnum } from '@/constants/pageSizeOptionList';
import StoreWorkProcess from '@/entity/StoreWorkProcess';
import { FormDataStoreWorkProcess } from '@/form/form-data/FormDataStoreWorkProcess';
import { StoreWorkProcessCommentPost } from '@/service-data/store-work-process/StoreWorkProcessCommentPost';
import { StoreWorkProcessPost } from '@/service-data/store-work-process/StoreWorkProcessPost';
import { StoreWorkProcessPut } from '@/service-data/store-work-process/StoreWorkProcessPut';
import { storeService } from '@/services';
import { storeWorkProcessService } from '@/services/store-work-process';
import { defineStore } from 'pinia';
import { computed, ref, } from 'vue';
/** 초기화 되지 않는 데이터 */
export const prevData = {
    pageSizeType: '',
    pageNumber: 0,
};
// 상점 업무처리
export const piniaStoreWorkProcess = defineStore('storeWorkProcess', () => {
    /** 상세정보 (상세보기에서 필요) */
    const itemDetail = ref(new StoreWorkProcess());
    /** 검색 */
    const filterOption = ref({
        searchWord: {
            /** 검색유형 */
            field: '',
            /** 검색어 */
            value: '',
        },
        pageSizeType: pageSizeEnum['50'],
        pageNumber: 1,
    });
    /** 상점리스트 */
    const storeList = ref([]);
    /** 리스트 */
    const itemList = ref([]);
    /** 페이지네이션 */
    const paginationData = ref({});
    /** 수정, 등록 폼데이터 */
    const formData = ref(new FormDataStoreWorkProcess());
    /** 비교를 위한 원본 데이터 */
    const originFormData = ref(new FormDataStoreWorkProcess());
    // computed
    /** 게시글 수 */
    const noticeTotalCount = computed(() => paginationData.value.total || 0);
    // method
    /**
     * res to form
     * 폼 데이터로 가공
     */
    const setFormData = (data) => {
        formData.value = new FormDataStoreWorkProcess(data);
        originFormData.value = new FormDataStoreWorkProcess(data);
    };
    /**
     * 답변 등록 페이지 폼 셋팅
     * 조회 후 작성자 데이터와 병합해서 사용해야 함.
     */
    const setFormDataForCreateReplyPage = (res) => {
        const data = Object.assign(res, {
            title: `RE: ${res.title}`,
            parentBody: res.body,
            body: '',
            parentId: res.id,
        });
        setFormData(data);
    };
    /**
     * 리스트 조회
     */
    const getItemList = async () => {
        const response = await storeWorkProcessService.getItemList({
            pageNumber: filterOption.value.pageNumber,
            pageSize: filterOption.value.pageSizeType,
        });
        itemList.value = response.list;
        paginationData.value = response.paginationData;
    };
    /**
     * 단건 조회
     */
    const getItem = async (id) => {
        const response = await storeWorkProcessService.getItem(id);
        itemDetail.value = response;
        return response;
    };
    /**
     * 삭제
     */
    const deleteNotice = async (id) => {
        const response = await storeWorkProcessService.deleteItem(id);
        return response;
    };
    /**
     * 단건 수정
     */
    const updateNotice = async () => {
        const serviceData = new StoreWorkProcessPut(formData.value);
        const response = await storeWorkProcessService.updateItem(serviceData);
        return response;
    };
    /**
     * 단건 등록
     */
    const createNotice = async () => {
        const serviceData = new StoreWorkProcessPost(formData.value);
        const response = await storeWorkProcessService.createItem(serviceData);
        return response;
    };
    /**
     * 답변 등록
     */
    const createReply = async () => {
        const serviceData = new StoreWorkProcessCommentPost(formData.value);
        const response = await storeWorkProcessService.createReply(serviceData);
        return response;
    };
    /**
     * 상점 리스트 조회
     */
    const getStoreList = async () => {
        const param = {
            pageNumber: 1,
            pageSize: 1000,
            hubId: formData.value.selectedHubId,
            filters: [],
            sortOption: [],
        };
        const response = await storeService.getStoreManagementList(param);
        storeList.value = response.data.list;
    };
    return {
        setFormDataForCreateReplyPage,
        storeList,
        setFormData,
        createNotice,
        updateNotice,
        deleteNotice,
        noticeTotalCount,
        itemList,
        originFormData,
        formData,
        paginationData,
        itemDetail,
        getItemList,
        getItem,
        filterOption,
        getStoreList,
        createReply,
    };
});
